import type { TntType } from '../../store/services/TimeInTransitService/types';

export interface TntUploadTypeConfig {
  /** Exact CSV header row the upload requires, in order. */
  requiredHeaders: string[];
  /** Filename (without .csv) used by the Download Template button. */
  templateFileName: string;
  /** tnt_management source name, used to find this type's existing dataset. */
  tntSourceName: string;
  /** Value sent as fileTntSource when creating a dataset. */
  fileTntSource: string;
}

const CARRIER_SELECTION_HEADERS = [
  'originCountry',
  'originPostal',
  'destinationCountry',
  'destinationPostal',
  'carrierServiceMethodId',
  'tnt',
];

const PROMISE_HEADERS = ['originCountry', 'originPostal', 'destinationCountry', 'destinationPostal', 'tnt'];

export const TNT_UPLOAD_TYPE_CONFIG: Record<TntType, TntUploadTypeConfig> = {
  production: {
    requiredHeaders: CARRIER_SELECTION_HEADERS,
    // Existing filename users already recognize (see TntUpload.tsx) — do not rename.
    templateFileName: 'time-in-transit-template',
    tntSourceName: 'partner-provided-postal',
    fileTntSource: 'PARTNER_PROVIDED_POSTAL',
  },
  simulation: {
    requiredHeaders: CARRIER_SELECTION_HEADERS,
    templateFileName: 'time-in-transit-simulation-template',
    tntSourceName: 'partner-provided-postal',
    fileTntSource: 'PARTNER_PROVIDED_POSTAL',
  },
  carrier_default: {
    requiredHeaders: CARRIER_SELECTION_HEADERS,
    templateFileName: 'carrier-default-time-in-transit-template',
    tntSourceName: 'carrier-default',
    fileTntSource: 'CARRIER_DEFAULT',
  },
  promise: {
    requiredHeaders: PROMISE_HEADERS,
    templateFileName: 'delivery-promise-time-in-transit-template',
    tntSourceName: 'csm-blend-partner-provided',
    // CHOSEN, NOT VERIFIED: stage returned 401 and prod returned 403 for the
    // VERIFIED against the prod tnt_source table (2026-09-16):
    //   name=csm-blend-partner-provided, fileUploadTntSourceName=csm-blend-partner-provided,
    //   carrierScopeDefinition.type=blend, dataSetScopeDefinition={partnerId:true,carrierId:false},
    //   partnerAccessType=WRITE.
    // Note the value is the source name verbatim, NOT a SCREAMING_SNAKE variant — only the two
    // oldest sources (PARTNER_PROVIDED_POSTAL, CARRIER_DEFAULT) use that older convention.
    // This MUST match that row's file_upload_tnt_source_name exactly. Keep this the single
    // source of truth for the literal — do not duplicate it elsewhere.
    fileTntSource: 'csm-blend-partner-provided',
  },
};

/** Templates are generated client-side, headers only — no static asset, no sample rows. */
export const buildTemplateCsv = (type: TntType): string => TNT_UPLOAD_TYPE_CONFIG[type].requiredHeaders.join(',');
